











































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { vxm } from '@/store'

@Component
export default class SuppliersConfiguration extends Vue {
  @Prop({ required: true }) configuration!: any
  @Prop({ required: true }) availableSuppliers!: any[]
  @Prop({ default: false }) readonly!: boolean

  private searchTimeouts: { [key: number]: number } = {}

  public beforeDestroy(): void {
    // Clean up all timeouts
    Object.values(this.searchTimeouts).forEach(clearTimeout)
  }

  private onSupplierChange(index: number, supplierId: string | null): void {
    const config = this.configuration.suppliers[index]
    config.supplier = supplierId
    if (!supplierId) {
      config.brand = null
      config.availableBrands = []
      config.brandSearchQuery = ''
    }
    this.clearSearchTimeout(index)
    this.$emit('supplier-change', index, supplierId)
  }

  private onBrandChange(index: number, brandId: string | null): void {
    this.configuration.suppliers[index].brand = brandId
    this.$emit('brand-change', index, brandId)
  }

  private onBrandSearch(index: number, searchQuery: string): void {
    const config = this.configuration.suppliers[index]
    if (!config.supplier) return

    config.brandSearchQuery = searchQuery

    if (!searchQuery || searchQuery.length < 2) {
      config.availableBrands = []
      this.clearSearchTimeout(index)
      return
    }

    this.clearSearchTimeout(index)
    this.searchTimeouts[index] = window.setTimeout(() => {
      this.performBrandSearch(index, searchQuery)
    }, 300)
  }

  private clearSearchTimeout(index: number): void {
    if (this.searchTimeouts[index]) {
      clearTimeout(this.searchTimeouts[index])
      delete this.searchTimeouts[index]
    }
  }

  private performBrandSearch(index: number, searchQuery: string): void {
    const config = this.configuration.suppliers[index]
    config.loadingBrands = true
    this.$axios
      .get(
        `/v4/site/products/brands/search?supplierIds[]=${config.supplier}&query=${encodeURIComponent(searchQuery)}`,
      )
      .then((response) => {
        config.availableBrands = response.data.data || []
        config.loadingBrands = false
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, this.$t('Failed to search brands'))
        config.loadingBrands = false
      })
  }

  private addSupplierConfig(): void {
    this.configuration.suppliers.push({
      supplier: null,
      brand: null,
      discount_percent: 0,
      profit_percent: 0,
      profit_amount: 0,
      availableBrands: [],
      loadingBrands: false,
      brandSearchQuery: '',
      profitPercentages: {
        standard: {},
        suv: {},
        van: {},
      },
    })
  }

  private removeSupplierConfig(index: number): void {
    if (this.configuration.suppliers.length > 1) {
      this.clearSearchTimeout(index)
      this.configuration.suppliers.splice(index, 1)
    }
  }

  private get supplierRules(): Array<(v: any) => boolean | string> {
    return [(v: any) => !!v || this.$t('Supplier is required')]
  }

  private get brandRules(): Array<(v: any) => boolean | string> {
    return [
      (v: any) => !!v || this.$t('Brand is required'),
      (v: any) => !this.isSupplierBrandCombinationUsed(v) || this.$t('This supplier-brand combination is already used'),
    ]
  }

  private isSupplierBrandCombinationUsed(brandId: string | null): boolean {
    if (!brandId) return false

    const combinations = this.configuration.suppliers
      .filter((config: any) => config.supplier && config.brand)
      .map((config: any) => `${config.supplier}-${config.brand}`)

    const duplicates = combinations.filter((combo: string, index: number) =>
      combinations.indexOf(combo) !== index
    )

    return duplicates.length > 0
  }

  public validateForms(): boolean {
    let isValid = true

    if (this.$refs.suppliersForm) {
      const suppliersFormValid = (this.$refs.suppliersForm as any).validate()
      isValid = isValid && suppliersFormValid
    }

    return isValid
  }

  public getSupplierName(supplierId: string): string {
    const supplier = this.availableSuppliers.find((s) => s.id === supplierId)
    return supplier ? supplier.name : this.$t('Unknown Supplier')
  }

  public getBrandName(supplierId: string, brandId: string): string {
    for (const config of this.configuration.suppliers) {
      if (config.supplier === supplierId) {
        const brand = config.availableBrands.find((b: any) => b.id === brandId)
        if (brand) {
          return brand.name
        }
      }
    }
    return this.$t('Unknown Brand')
  }
}
